<template>
  <el-dialog :close-on-click-modal="false" :visible="visible" title="门诊慢特病种目录查询" append-to-body width="80rem" @open="open" @close="close">
    <div>
      <div class="views-search left-pad">
        <div style="display:flex;">
          <el-input v-model="condition.门慢门特病种目录代码" placeholder="门慢门特病种目录代码" size="small" clearable class="edit-wide left-pad"></el-input>
          <el-input v-model="condition.门慢门特病种名称" placeholder="门慢门特病种名称" size="small" clearable class="edit-wide left-pad"></el-input>
          <el-button type="primary" size="small" icon="el-icon-search" class="left-pad" :loading="loading" @click="handleSearch">查询</el-button>
          <el-button type="primary" size="small" icon="el-icon-finished" class="left-pad" @click="select">选择</el-button>
          <span class="left-pad" v-if="selectItem">当前选中：{{selectItem.门慢门特病种名称}}</span>
        </div>
      </div>

      <div class="views-table">
        <el-table :data="result.items" v-loading="loading" highlight-current-row @current-change="currentChange" @row-dblclick="rowDblclick" style="width: 100%" height="100%" class="main-table">
          <el-table-column prop="门慢门特病种大类代码" label="门慢门特病种大类代码"></el-table-column>
          <el-table-column prop="门慢门特病种大类名称" label="门慢门特病种大类名称" min-width="120"></el-table-column>
          <el-table-column prop="门慢门特病种目录代码" label="门慢门特病种目录代码"></el-table-column>
          <el-table-column prop="门慢门特病种名称" label="门慢门特病种名称" min-width="100"></el-table-column>
          <el-table-column prop="医保区划" label="医保区划" width="120"></el-table-column>
          <el-table-column prop="病种内涵" label="病种内涵" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="views-pagination">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="page" @current-change="page" :current-page.sync="pageIndexOnView" :page-size.sync="condition.pageSize" :total="result.total"></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/common/api';

export default {
  name: 'med-opsp-dise',
  props: {
    visible: { type: Boolean, default: false },
    name: { type: String, default: null },
    code: { type: String, default: null },
  },
  data () {
    return {
      loading: false,
      pageIndexOnView: 1,
      condition: {
        门慢门特病种目录代码: '',
        门慢门特病种名称: '',
        pageIndex: 0,
        pageSize: 20
      },
      result: [],
      selectItem: null
    };
  },
  watch: {
    pageIndexOnView (val) {
      if (val) {
        this.condition.pageIndex = val - 1
      }
    }
  },
  methods: {
    open () {
      this.selectItem = null
      this.condition.门慢门特病种目录代码 = this.code
      this.condition.门慢门特病种名称 = this.name
      this.handleSearch()
    },
    close () {
      this.$emit('update:visible', false)
    },
    handleSearch () {
      this.pageIndexOnView = 1
      this.page()
    },
    page () {
      this.loading = true
      api.getMedCatalog('1309', this.condition).then(res => {
        this.result = res
      }).finally(() => {
        this.loading = false
      })
    },
    rowDblclick (row) {
      if (row) {
        this.selectItem = row
        this.select()
      }
    },
    currentChange (currentRow, oldCurrentRow) {
      if (currentRow) {
        this.selectItem = currentRow
      }
    },
    select () {
      if (!this.selectItem) {
        this.$message.warning('请选择一条数据！');
        return;
      };
      this.$emit('update:name', this.selectItem.门慢门特病种名称)
      this.$emit('update:code', this.selectItem.门慢门特病种目录代码)
      this.close()
    }
  },
};
</script>
